import AppButton from 'components/atoms/AppButton/AppButton'
import Layout from 'layout/Layout'
import { useMemo, useCallback } from 'react'
import { useParams } from 'react-router-dom'
import SorterOrderDetail from 'orders/presentation/components/organisms/SorterOrderDetail/SorterOrderDetail'
import ClassificationOrderDetail from 'orders/presentation/components/organisms/ClassificationOrderDetail/ClassificationOrderDetail'
import { LoaderTransparent } from 'components/molecules/LoaderTransparent/LoaderTransparent'
import HeaderPageSection from 'core/presentation/components/molecules/HeaderPageSection/HeaderPageSection'
import { OperationModeBadge } from 'core/presentation/components/molecules/OperationModeBadge/OperationModeBadge'
import { useOrderDetail } from '../../../hooks/useOrderDetail'
import { useOrderProgress } from '../../../hooks/useOrderProgress'
import { formatDate, formatHour } from 'utils/formatting'
import { isSorterMode } from 'utils/operationModeUtils'

export default function ShowOrderDetailsPage() {
    const { orderId } = useParams()
    const orderIdNumber = Number(orderId)

    const { order, loading } = useOrderDetail(orderIdNumber)
    const { progress, loading: progressLoading, refetch: refetchProgress } = useOrderProgress(orderIdNumber)

    const handleRefresh = useCallback(() => {
        refetchProgress()
    }, [refetchProgress])

    const subtitle = useMemo(() => {
        const lastUpdate = progress?.lastUpdate ?? order?.lastUpdate
        if (!lastUpdate) return undefined
        return `Última actualización ${formatDate(lastUpdate)} ${formatHour(lastUpdate)}`
    }, [progress?.lastUpdate, order?.lastUpdate])

    const operationMode = useMemo(() => {
        if (progress?.classificationType) {
            return { id: 0, code: progress.classificationType, name: progress.classificationType }
        }
        return order?.operationMode
    }, [progress?.classificationType, order?.operationMode])

    const handleSearch = useCallback((containerCode: string) => {
        refetchProgress(containerCode || undefined)
    }, [refetchProgress])

    const breadcrumbCode = progress?.code ?? order?.description ?? String(orderIdNumber)

    return (
        <Layout>
            {(loading || progressLoading) && <LoaderTransparent />}
            <HeaderPageSection
                title="Detalle de la orden"
                subtitle={subtitle}
                showGoBack={true}
                breadcrumbItems={[
                    { label: 'Ordenes', path: '/orders' },
                    { label: `Orden #${breadcrumbCode}`, path: `/orders/show/details/${orderIdNumber}` },
                ]}
                badgeNode={
                    operationMode && (
                        <OperationModeBadge operationMode={operationMode} />
                    )
                }
            >
                <div className="flex gap-2 items-center">
                    <AppButton
                        title="Refrescar"
                        state="ghost"
                        className="text-sm font-bold"
                        onClick={handleRefresh}
                    />
                </div>
            </HeaderPageSection>

            {order && (
                isSorterMode(operationMode ?? null)
                    ? <SorterOrderDetail progress={progress} onSearch={handleSearch} />
                    : <ClassificationOrderDetail progress={progress} onSearch={handleSearch} />
            )}
        </Layout>
    )
}
